import { Card, Heading, Text } from "@/design-system";
import { STEPS } from "../constants";
import { PageSection } from "@/pages/landingPage/components/pageSection";

export const StepsSection = () => (
  <PageSection labelledBy="como-funciona-title">
    <Heading level={2} id="como-funciona-title" className="mb-8 lg:mb-10">
      Como funciona a cobrança via WhatsApp da Fidexa
    </Heading>

    <ol className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
      {STEPS.map((step, index) => (
        <li key={step.title} className="flex">
          <Card className="flex w-full flex-col gap-3">
            <span
              aria-hidden="true"
              className="bg-ds-brand-600 text-ds-on-solid font-ds-sans text-ds-body flex size-10 items-center justify-center rounded-full font-semibold"
            >
              {index + 1}
            </span>
            <Heading level={3} size={4}>
              {step.title}
            </Heading>
            <Text tone="muted">{step.desc}</Text>
          </Card>
        </li>
      ))}
    </ol>
  </PageSection>
);
